"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const utils_1 = require("../utils");
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("form")(({ theme }) => ({
    "> div, > label": {
        display: "block",
    },
    // Space between groups
    "> :not(:last-child)": {
        marginBottom: 34 - theme.space.small,
    },
    // Space between children _inside_ groups
    "> :not(:last-child) > *": {
        marginBottom: theme.space.small,
    },
    // Space between siblings inside children inside groups
    "> * > *:not(:last-child)": {
        marginRight: theme.space.small,
    },
}));
const Form = props => (React.createElement(Container, Object.assign({}, props, { onKeyDown: (ev) => {
        if (utils_1.isCmdEnter(ev) && props.onSubmit) {
            props.onSubmit(ev);
        }
    } })));
exports.default = Form;
//# sourceMappingURL=Form.js.map